import React from 'react'

const Username = () => {
  return (
    <div className='text-black font-bold p-5 underline font-serif'>
        
        Your user number has been forwarded to your e-mail. Please check and try again.
        
    </div>
  )
}

export default Username